module.exports = __webpack_public_path__ + "static/wechat-qrcode-5c9b356dced005484496cd9eaf53b2e2.png";